import { Component, OnInit ,ViewContainerRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFirestore ,AngularFirestoreCollection} from '@angular/fire/firestore';
import 'rxjs/add/operator/map';
import { AuthService } from '../../service/auth.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  image: File;
  termsForm: FormGroup;
 
  FOLDER: any = 'terms/';
  loading: any = false;
  termsimgurl: any = '';
  edit: any = false;
  id: any;
  error: any = '';
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private auth: AuthService,
    public toastr: ToastsManager,vcr: ViewContainerRef) { 
      this.toastr.setRootViewContainerRef(vcr);
    }

  ngOnInit() {
    this.termsForm = this.form.group({
      content: ['', [Validators.required]],
      upload_Image: ['', []]
    });
    this.checkdata();
  }
  async checkdata() {
    try {
      const termscondata = await this.afs.collection('/Terms').valueChanges();
      termscondata.subscribe(Termsdata => {
        console.log(Termsdata);

        if (Termsdata.length >= 1) {
          this.termsForm.get('content').setValue(Termsdata[0]['heading']);
          this.termsimgurl = Termsdata[0]['imageurl'];
          this.edit = true;
          this.id = Termsdata[0]['id'];
        }
      });
    } catch (error) {
      this.error = 'Somthing went wrong please try later';
      this.toastr.error('Somthing went wrong please try later', 'Oops!');
      console.log(error);
    }
  }
  changeListner2(event) {
    this.image = <File>event.target.files[0];
  }

  async addterms(value, valid) {
    this.error = '';
    if (valid || this.edit) {
      this.loading = true;
      try {
        let uploadedimage;
        if (this.edit) {
          if (this.image) {
            uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
            await this.afs.doc('Terms/' + this.id).update({ heading: value.content, imageurl: uploadedimage['Location'] });
          } else {
            await this.afs.doc('Terms/' + this.id).update({ heading: value.content });
          }
        } else {
          if (!this.image) {
            this.error = 'Image is required';
            this.toastr.error('Image is required!', 'Oops!');
          }
          uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
          const addterms = await this.afs.collection('Terms')
            .add({ heading: value.content, imageurl: uploadedimage['Location'], type: 'mobile' });
          const id = addterms.id;
          await this.afs.doc(`/Terms/${id}`).update({ id: id });
        }
        this.loading = false;
        this.toastr.success('Terms and Conditions Updated!', 'Success!');

      } catch (error) {
        this.loading = false;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/extras/terms-conditions/terms-conditions.component.ts